import React from 'react';
import { Chip } from '@mui/material';
import { ChargerType } from '../services/chargerService';
import {
  BatteryChargingFull,
  Power,
  ElectricBolt,
  Bolt,
} from '@mui/icons-material';

interface ChargerTypeChipProps {
  type: ChargerType;
  size?: 'small' | 'medium';
  showIcon?: boolean;
}

export const ChargerTypeChip: React.FC<ChargerTypeChipProps> = ({
  type,
  size = 'small',
  showIcon = true
}) => {
  const getTypeConfig = (type: ChargerType) => {
    switch (type) {
      case ChargerType.PORTABLE_AC_SINGLE_PHASE:
        return {
          label: 'Portable AC (1φ)',
          color: 'primary',
          icon: <Power fontSize="small" />,
        };
      case ChargerType.PORTABLE_AC_THREE_PHASE:
        return {
          label: 'Portable AC (3φ)',
          color: 'primary',
          icon: <BatteryChargingFull fontSize="small" />,
        };
      case ChargerType.PORTABLE_DC_FAST:
        return {
          label: 'Portable DC Fast',
          color: 'secondary',
          icon: <Bolt fontSize="small" />,
        };
      case ChargerType.WALL_MOUNTED_AC:
        return {
          label: 'Wall-Mounted AC',
          color: 'info',
          icon: <Power fontSize="small" />,
        };
      case ChargerType.WALL_MOUNTED_DC:
        return {
          label: 'Wall-Mounted DC',
          color: 'warning',
          icon: <ElectricBolt fontSize="small" />,
        };
      default:
        return {
          label: type,
          color: 'default',
          icon: <Power fontSize="small" />,
        };
    }
  };

  const config = getTypeConfig(type);

  return (
    <Chip
      label={config.label}
      color={config.color as any}
      size={size}
      icon={showIcon ? config.icon : undefined}
      variant="outlined"
    />
  );
};
